import Button from '@/common/components/Button'
import Modal from '@/common/components/Modal'
import { ModalMessageSimple } from '@/common/components/ModalMessageSimple'
import { FormTransformers } from '@/common/utils/formTransformers'
import { useDeleteEstablishmentTechnicalProfessional } from '@/features/maintenance/establishmentTechnicalProfessionals/hooks/useDeleteEstablishmentTechnicalProfessional'
import { useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

export const ModalDeleteEstablishmentTechnicalProfessional = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  const [isOpen, setIsOpen] = useState(false)
  const [messages, setMessages] = useState<string[] | boolean>(false)

  const onSuccess = () => {
    queryClient.invalidateQueries({ queryKey: ['establishmentTechnicalProfessionals'] })
    navigate('/establishment-technical-professionals')
  }

  const { mutate: deleteCompanyBranchAdditionalDocument, isPending: deleteCompanyBranchAdditionalDocumentIsPending } =
    useDeleteEstablishmentTechnicalProfessional({
      id: id || '',
      onSuccess,
      onError: FormTransformers.errorsTransformer({ setMessages }),
    })

  return (
    <>
      <Modal
        isOpen={isOpen}
        setIsOpen={(value) => setIsOpen(value)}
        Trigger={
          <Button
            name="delete_establishment_technical_professional"
            variant="outline-error"
            operationKlassToCheckPermission="Admin::Maintenance::EstablishmentTechnicalProfessionals::Destroy"
          >
            Deletar
          </Button>
        }
        triggerAsChild
        title="Confirmar Exclusão"
        subtitle="Tem certeza que deseja excluir este profissional? Esta ação não pode ser desfeita."
        titleClass="text-2xl"
        subtitleClassName="mt-1 text-sm"
        showClose={false}
        useCancellableFooter
        disabled={deleteCompanyBranchAdditionalDocumentIsPending}
        confirmButtonIsLoading={deleteCompanyBranchAdditionalDocumentIsPending}
        onConfirm={() => deleteCompanyBranchAdditionalDocument()}
      />

      <ModalMessageSimple messages={messages} setMessages={setMessages} isError />
    </>
  )
}
